module.exports = __webpack_public_path__ + "assets/icon-arrow-down.e6369416.png";